import { useRMSelector } from 'redux/hooks';

export const useGeneralDispensingProperties = () => {
  return useRMSelector((state) => state.generalDispensingProperties);
};
